import { HttpResponse } from '@angular/common/http';
import { Component, inject, model, OnDestroy, OnInit, signal } from '@angular/core';
import {
  UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators,
} from '@angular/forms';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

import { LocationService } from '../../services/location.service';
import { AdminService } from '../../services/admin.service';
import { WarehousesService } from '../../services/warehouses.service';
import { rxResource } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { Location } from '../../../models/location.model';
import { RoleService } from '../../../role/role.service';
import { RequirementsService } from '../../services/requirements.service';
import { RequirementBrand } from '../../../models/requirement-model';
import { BrandsService } from '../../services/brands.service';

@Component({
    selector: 'app-admin-location',
    templateUrl: './admin-location.component.html',
    styleUrls: ['./admin-location.component.scss', '../admin-main.common.scss'],
    standalone: false
})
export class AdminLocationComponent {
  formGroup = this.fb.group({
    name: this.fb.control('', Validators.required),
    address: this.fb.control('', Validators.required),
    warehouse_id: this.fb.control(null, Validators.required),
  });

  requirementForm = this.fb.group({
    name: this.fb.control('', Validators.required),
    max_daily_bookings: this.fb.control(null),
    duration: this.fb.control(null),
    price: this.fb.control(null),
    location_ids: this.fb.control([]),
  });

  warehouseForm = this.fb.group({
    name: this.fb.control('', [Validators.required]),
    address: this.fb.control('', [Validators.required]),
  });

  warehouses = this.warehouseService.warehouses;

  locations = this.locationService.locations;

  selectedBrandIds = model<number[]>();
  existingRequirementBrands = signal<RequirementBrand[]>([]);

  public brandsService = inject(BrandsService);
  brands = this.brandsService.brands.value;
  
  public requirementsService = inject(RequirementsService);

  public readonly roleService = inject(RoleService);

  constructor(
    private fb: UntypedFormBuilder,
    public companyService: AdminService,
    public locationService: LocationService,
    public warehouseService: WarehousesService,
  ) {
  }

  prepareRequirementForForm(value) {
    this.existingRequirementBrands.set(value?.requirement_brands_attributes || []);
    this.selectedBrandIds.set(value?.requirement_brands_attributes
      ?.filter(rb => !rb._destroy)
      ?.map(rb => rb.brand_id) || []);

    return value;
  }

  prepareRequirementForSubmit(value) {
    const existing = this.existingRequirementBrands() || [];

    // Brands currently selected
    const selectedSet = new Set(this.selectedBrandIds());

    // Map existing ones
    const updatedAttributes: RequirementBrand[] = [];

    // Preserve or mark for destruction
    for (const rb of existing) {
      if (selectedSet.has(rb.brand_id)) {
        updatedAttributes.push({ ...rb, _destroy: false });
        selectedSet.delete(rb.brand_id);
      } else {
        if (rb.id) {
          updatedAttributes.push({ ...rb, _destroy: true });
        }
      }
    }
    // What remains in the set are new relationships
    selectedSet.forEach((brandId) => {
      updatedAttributes.push({ brand_id: brandId });
    });

    value.requirement_brands_attributes = updatedAttributes;

    return value;
  }
}
